<template>
<Layout :footer-style="2">
  <div class="JoinPartners">
    <div class="JoinPartners_content">
      <StaticBanner :banner-date="bannerDate"></StaticBanner>
      <dropdownMenu :pkname="'加入生态伙伴'" :pktype="'joinpartners'"></dropdownMenu>
      <div class="titles" v-if="windowWidth>767">
        <div class="in_titles">
          <div class="in_titles_left">
            <img class="in_titles_left_img" src="../assets/images/industry/tb.png" alt="">
            <div><span style="margin-right: 10px;">&gt;</span><span style="font-size: 18px;">加入生态伙伴</span></div>
          </div>
          <div class="in_titles_right">
            <a href="#aboutNum" :class="val == '1' ? 'changes' : ''" @click="titleRouter('about','1')">公司介绍</a>
              <a  :class="val == '2' ? 'changes' : ''" @click="titleRouter('about','2')">历史沿革</a>
              <a href="#honorSwipe" :class="val == '3' ? 'changes' : ''" @click="titleRouter('about','3')">荣誉与资质</a>
              <a :class="val == 'parent' ? 'changes' : ''" @click="titleRouter('parent')" >生态伙伴</a>
              <a :class="val == '4' ? 'changes' : ''" href="#join_us" @click="titleRouter('about','4')">加入我们</a>
              <a :class="val == 'info' ? 'changes' : ''" @click="titleRouter('info')" >最新资讯</a>
          </div>
        </div>
      </div>
      <div class="content_body container">
        <div class="text_title">
          <div>感谢您对博信诚云的关注。</div>
          <div>请填写下面的表格以便加入生态伙伴，</div>
          <div>我们会尽快联系您。</div>
        </div>
        <div class="from_contact">
          <div class="from_contact_title">您的个人信息</div>
          <div class="from_contact_main">
            <div class="from_contact_input">
              <div>姓名</div>
              <input type="text" v-model="name" placeholder="请输入您的真实姓名">
            </div>
            <div class="from_contact_input">
              <div>职务</div>
              <input type="text" v-model="post" placeholder="请输入您的职务">
            </div>
            <div class="from_contact_input">
              <div>邮箱</div>
              <input type="text" v-model="meail" placeholder="请输入您的邮箱地址">
            </div>
            <div class="from_contact_input">
              <div>手机</div>
              <input type="text" v-model="templetes" placeholder="请输入您的手机号码">
            </div>
          </div>
        </div>
        <div class="from_contact">
          <div class="from_contact_title">您的公司信息</div>
          <div class="from_contact_main">
            <div class="from_contact_input">
              <div>公司姓名</div>
              <input type="text" v-model="names" placeholder="请输入您所在的企业名称">
            </div>
            <div class="from_contact_input">
              <div>公司所在地</div>
              <input type="text" v-model="domicile" placeholder="请输入您的企业所在地">
            </div>
            <div class="from_contact_input">
              <div>公司电话号码</div>
              <input type="text"  v-model="phone" placeholder="请输入您的联系电话">
            </div>
            <div class="from_contact_input">
              <div>公司地址</div>
              <input type="text" v-model="Company" placeholder="请输入您的公司地址">
            </div>
            <div class="from_contact_input">
              <div>公司网址</div>
              <input type="text" v-model="website" placeholder="请输入您的公司网址">
            </div>
          </div>
        </div>
        <div class="join_btn">
          <div class="join_btn_title" @click="submit()">提交申请</div>
        </div>
      </div>
      <div class="JoinProcess">
        <img src="../assets/images/aboutUs/JoinProcess.png" alt="">
      </div>
    </div>
  </div>
</Layout>
</template>
<style lang="scss">
.JoinPartners{
  .JoinPartners_content {
    margin: 0 auto;
    max-width: 1920px;
    margin-top: 80px;
    background: #f7f7f7;
    .titles {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      color: #12294f;
      .in_titles {
        display: flex;
        max-width: 1440px;
        height: 70px;
        width: 100%;
        padding: 0 70px;
        align-items: center;
  
        .in_titles_left {
          display: flex;
          width: 50%;
          align-items: center;
          margin-left: 5%;
          .in_titles_left_img {
            height: 30%;
            margin-right: 10px;
          }
        }
        .in_titles_right {
          display: flex;
          flex: 1;
          justify-content: space-around;
          a{
            color: #12294f;
            padding: 20px 0;
            cursor: pointer;
          }
          .changes{
            color: #186BB3;
            border-bottom: 4px solid #186BB3;
          }
        }
      }
    }
    .content_body{
      padding: 0 10%;
      font-size: 16px;
      .text_title{
        padding: 30px 0;
        font-size: 2rem;
      }
      .from_contact{
        .from_contact_title{
          margin-bottom: 20px;
        }
        .from_contact_main{
          .from_contact_input{
            margin: 15px 0;
            input{
              border: 0;
              color: rgba(0, 0, 0, 0.1411764706);
              border-bottom: 1px solid rgba(0, 0, 0, 0.1411764706);
              border-radius: 0;
              &:focus{
                border: 0;
                border-bottom: 1px solid rgba(0, 0, 0, 0.1411764706);
              }
            }
          }
        }
      }
      .join_btn{
        padding: 50px 0 30px 0;
        .join_btn_title{
          width: 250px;
          text-align: center;
          padding: 10px 20px;
          font-size: 18px;
          font-family: "MiSans";
          color: rgb(255, 255, 255);
          border-radius: 3px;
          background-color: rgb(0, 91, 171);
        }
      }
    }
    .JoinProcess{
      background: white;
      padding: 50px 10%;
      img{
        margin: 0 50%;
        transform: translateX(-50%);
      }
    }
  } 
}
</style>
<script>// 引入
import { messageControl } from '@/views/messageDialog/messageDialog.js'
import Layout from '../components/common/Layout'
import StaticBanner from "@/components/common/staticBanner/index.vue"
import dropdownMenu from "@/components/common/dropdownMenu.vue"
export default {
  name: 'JoinPartners',
  components:{StaticBanner,Layout,dropdownMenu},
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,
      bannerDate: {
        url: require("@/assets/images/aboutUs/banner09-02.png"),
        title: "加入生态合作伙伴",
        content: "十余年专注为中高端客户提高全场景一站式的智慧业财一体化服务",
        btn:false,
      },
      val:'parent',
      name: '',
      post: '',
      meail: '',
      templetes: '',
      names: '',
      domicile: '',
      phone: '',
      Company: '',
      website: '',
    }
  },
  mounted() {
    // 初始化绑定
    this.messageComponent = new messageControl()
  },
  methods:{
    titleRouter(type,val){
      if (type == 'about') {
        sessionStorage.setItem('a-id',val)
        this.$router.push({
        path: '/about-us'
      })
      }
      if (type == 'info') {
        this.$router.push({
        path: '/information'
      })
      }
    },
    submit(){
      if(!this.templetes){
        this.messageComponent.message({ type: 'error', content: '请输入手机号', })
        return false
      }
      this.name = ''
      this.post = ''
      this.meail = ''
      this.templetes = ''
      this.names = ''
      this.phone = ''
      this.domicile = ''
      this.company = ''
      this.website = ''
      this.messageComponent.message({ type: 'success', content: '提交成功' })
    }
  },
}
</script>